import SectionDescription from './sectionDescription'

export default SectionDescription



// WEBPACK FOOTER //
// ./client/pages/home/sectionDescription/index.tsx